import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import AppView from '~common/components/app-view/index';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {APIError} from '~common/lib/types';
import Renderers from '~common/lib/renderers';
import {Grid} from '@mui/material';
import DashboardElement from '~dashboard/components/elements/element';
import {Responsive, WidthProvider} from 'react-grid-layout';
// import {CompactType, Layout} from 'react-grid-layout/lib/utils';
import classNames from 'classnames';

import { Hidden, Avatar, Chip, Button} from '@mui/material'

import PortalUser from `~common/lib/portal-user-context`;

import translate from '../../../../../common/ui/components/i18n/i18n';


// These are here to load the renderers
import CountRenderer from '~dashboard/components/elements/count-renderer';
import TemplateElementRenderer from '~dashboard/components/elements/template-renderer';
import MultiCountRenderer from '~dashboard/components/elements/multi-count-renderer';
import BulletinsRenderer from '~dashboard/components/elements/bulletins-renderer';
import FormRenderer from '~dashboard/components/elements/form-renderer';
import ExternalLinkCardRenderer from '~links/components/link-card-renderer';
import AggregationRenderer from '~dashboard/components/elements/aggregation-renderer';
import CustomElementRenderer from '~dashboard/components/elements/custom-element-renderer';

// We _do_ have to register them
CustomElementRenderer.register()
CountRenderer.register()
MultiCountRenderer.register()
TemplateElementRenderer.register()
BulletinsRenderer.register()
FormRenderer.register()
ExternalLinkCardRenderer.register()
AggregationRenderer.register()


const ResponsiveReactGridLayout = WidthProvider(Responsive);

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  title: {
    borderBottom: '1px solid #ccc',
    paddingBottom: 5
  },
  gridColumns: {
    display: 'flex',
    flexDirection: 'row'
  },
  editorPanel: {
    backgroundColor: '#edf1f3',
    border: 'solid 1px #ccc',
    padding: 15,
    display: 'flex',
    transition: 'height .25s ease-in-out',
    flexDirection: 'column'
  },
  editorShown: {
    overflow: 'hidden',
    // margin: '-10px -25px 0px -25px',
    transition: 'height .25s ease-in-out',
    position: 'relative'
  },
  editorHidden: {
    height: 25,
    overflow: 'hidden',
    // margin: '-10px -25px 0px -25px',
    transition: 'height .25s ease-in-out',
    position: 'relative'
  },
  editorToggle: {
    position: 'absolute',
    bottom: 0,
    right: 10,
    opacity: 0.3
  },
  editorInstructionsArea: {
    padding: '15px 15px 30px 15px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  editorInstructions: {
    padding: '15px 15px 15px 15px'
  },
  chipArea: {
    justifyContent: 'center'
  },
  editorButtons: {
    minWidth: 100,
    display: 'flex',
    justifyContent: 'space-between'
  },
  editorSafeButtons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  editorDangerButtons: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  editorSaveButton: {
    marginRight: 15
  },
  editorCancelButton: {
    marginRight: 15,
  },
  editorResetButton: {
    marginLeft: 15
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  elements: Array<any>;
  status: 'loading' | 'ready';
  error?: any;
  layouts?: any;
  layoutBuffer?: any;
  breakpoints?: any;
  useCSSTransforms?: boolean;
  inEditMode?: boolean;
  currentBp?: string;
};

class Dashboard extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    let ae = false
    if (PortalUser.isLoggedIn() && PortalUser.hasOneOfFeatures(['dashboard_editor'])) {
      ae = true
    }
    this.state = {
      status: 'loading',
      elements: [],
      //breakpoints: {xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920},
      // These breakpoints are based on the material-ui breakpoints,
      // but account for the dashboard margins
      breakpoints: {xs: 0, sm: 540, md: 890, lg: 1220, xl: 1860},
      useCSSTransforms: false,
      allowEditing: ae,
      inEditMode: false
    };
  }

 componentDidMount() {
    const {breakpoints} = this.state;

    request
      .get('/api/dashboards')
      .set('accept', 'application/json')
      .send()
      .then((response) => {
        const elements = response.body.elements;
        const elementTypes = response.body.elementTypes;
        const layouts = response.body.layouts;

        // checkForNewLayouts(layouts, elements);

        if (!layouts || Object.keys(layouts).length == 0) {
          layouts = this.getInitialLayouts(elements);
        }

        this.setState({
          status: 'ready',
          elements: elements,
          elementTypes: elementTypes,
          layouts: layouts
        });
      })
      .catch((err) => {
        if (err.response && err.response.text) {
          const apiErr = new APIError();
          apiErr.type = 'http';
          apiErr.message = err.response.text;
          this.setState({status: 'ready', error: apiErr});
        }
      });
  }

  // checkForNewLayouts = (layouts: Array<any>, elements: Array<any>): any => {
  //   for (var elem of elements) {

  //     var id = elem.id.toString()

  //     if (layouts) {
  //       for (var sizeClass of layouts){

  //       }
  //     } 




  //     if (elem.elementAttributes) {
  //       const ea = elem.elementAttributes;
  //       // Layout attributes will be the new area with dashboard layout data is retained.
  //       // so if we have those, we should use them
  //       if (ea.layoutAttributes) {
  //         for (var sizeClass of Object.keys(ea.layoutAttributes)) {
  //           for (var elemAttr of sizeClass) {
  //             if (elemAttr["i"] == )
  //           }
  //         }
  //       }
  //     }    
  //   }
  // };

  handleElementsUpdate = (elements: any, elementTypes: Array<any>, layouts: any): void => {
    this.setState({
      status: 'ready',
      elements: elements,
      elementTypes: elementTypes,
      layouts: layouts
    });
  }

  getInitialLayouts = (elements: Array<any>): any => {
    const initialLayouts = {xs: [], sm: [], md: [], lg: [], xl: []};

    let idx = -1;
    const layouts = elements.reduce((lys, elem) => {
      idx++;
      idx = 0
      // Set the defaults first
      // These are the settings that are applied if an element does not have settings or is missing them.
      const xl = {
        i: elem.id.toString(),
        x: 0,
        y: idx,
        w: 4,
        h: 8,
        minW: 1,
        maxW: 12
      };
      const lg = {
        i: elem.id.toString(),
        x: 0,
        y: idx,
        w: 6,
        h: 8,
        minW: 1,
        maxW: 12
      };
      const md = {
        i: elem.id.toString(),
        x: 0,
        y: idx,
        w: 8,
        h: 8,
        minW: 3,
        maxW: 12
      };
      const sm = {
        i: elem.id.toString(),
        x: 0,
        y: idx,
        w: 3,
        h: 8,
        minW: 4,
        maxW: 12
      };
      const xs = {
        i: elem.id.toString(),
        x: 0,
        y: idx,
        w: 3,
        h: 8,
        minW: 4,
        maxW: 12
      };

      // This is where we are going to transform the initial values.
      if (elem.elementAttributes) {
        const ea = elem.elementAttributes;
        // Layout attributes will be the new area with dashboard layout data is retained.
        // so if we have those, we should use them
        if (ea.layoutAttributes) {
          for (var attr of Object.keys(ea.layoutAttributes)) {
            const val = ea.layoutAttributes[attr];

            switch (attr) {
              case 'xl':
                xl = this.applyLayoutToDefaults(xl, val);
                break;
              case 'lg':
                lg = this.applyLayoutToDefaults(lg, val);
                break;
              case 'md':
                md = this.applyLayoutToDefaults(md, val);
                break;
              case 'sm':
                sm = this.applyLayoutToDefaults(sm, val);
                break;
              case 'xs':
                xs = this.applyLayoutToDefaults(xs, val);
                break;
            }
          }
        } else {
          // This is to support existing grid attributes in a backward compatible way.
          // This will be deprecated in the future.
          if (ea.gridAttributes) {
            const val = ea.gridAttributes[attr];

            switch (attr) {
              case 'xl':
                xl.w = val;
                break;
              case 'lg':
                lg.w = val;
                break;
              case 'md':
                md.w = val;
                break;
              case 'sm':
                sm.w = val;
                break;
              case 'xs':
                xs.w = val;
                break;
            }
          }
        }

        lys.xs.push(xs);
        lys.sm.push(sm);
        lys.md.push(md);
        lys.lg.push(lg);
        lys.xl.push(xl);

        return lys;
      }
    }, initialLayouts);

    return layouts;
  };

  applyLayoutToDefaults = (layout: any, val: any): any => {
    for (var va of Object.keys(val)) {
      switch(va){
        case 'i':
          // No need to do anything with ID, since that should be set and aligned with the element
          break;
        case 'y':
          // No need to do anything with ID, since that should be set and aligned with the element
          layout[va] = val[va];
          break;
        default:
        layout[va] = val[va];
      }
    }

    return layout;
  };

  onLayoutChange = (currentLayout: any, layouts: any): void => {
    this.setState({layoutBuffer: layouts});
  };

  onBreakpointChange = (bp: any): void => {
    this.setState({currentBp: bp});
  };

  onEditorCancel = (): void => {
    this.setState({layoutBuffer: null, inEditMode: false});
  };

  onEditorSave = (): void => {

    const {layoutBuffer} = this.state;
    if (layoutBuffer) {
      // Save the dashboard layout
      request
        .post('/api/user/store/dashboard')
        .set('accept', 'application/json')
        .send(layoutBuffer)
        .catch((err) => {
          console.error('Error saving dashboard', err);
        });
    }
    this.setState({
      layouts: layoutBuffer,
      layoutBuffer: null,
      inEditMode: false
    });
    
  };

  onEditorReset = (): void => {
    const defaultLayouts = this.getInitialLayouts(this.state.elements);
    this.setState({layoutBuffer: defaultLayouts});
  };

  enterEditMode = () => {
    const {layouts} = this.state;
    this.setState({inEditMode: true, layoutBuffer: layouts});
  };

  deriveLayouts = (): any => {
    const {layouts, elements, layoutBuffer, inEditMode} = this.state;
    if (layoutBuffer) {
      // If we are editing, using the buffer
      return layoutBuffer;
    }
    

    if (layouts) {
      for (var key of Object.keys(layouts)) {
        const ly = layouts[key];
        for (var e of elements) {
          const foundLy = ly.find((l) => {
            if (e.id && e.id.toString() == l.i) {
              return true;
            }

            return false;
          });

          if (foundLy){
            continue
          } else {


            let elemLy = e.elementAttributes.layoutAttributes
            if (!elemLy) {
              // Insert default layout as backup
              elemLy = {}
            }
            
            let l = elemLy[key]
            if (!l) {
              l = defaultLayouts[key]
            } 
            l.i = e.id.toString()
            l.x = 0

            l.y = ly.length

            if (!l.w) {
              let lw = defaultLayouts[key]
              l.w = lw.w
            } 
          
            if (!l.h) {
              let lh = defaultLayouts[key]
              l.h = lh.h
            } 

            ly.push(l)
          }
        }
      }
    }

    return layouts;
  };

  renderEditorPanel = (): any => {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {inEditMode, allowEditing, currentBp} = this.state;
    
    if (!allowEditing) {
      return null;
    }

    let editorClass = classes.editorHidden;
    let editorPanel = null;

    const sizer = (
      <span>
        <Hidden only={['sm', 'md', 'lg', 'xl']}>
          <Chip
            avatar={<Avatar>XS</Avatar>}
            label="Extra Small"
            className={classes.chip}
          />
        </Hidden>
        <Hidden only={['xs', 'md', 'lg', 'xl']}>
          <Chip
            avatar={<Avatar>SM</Avatar>}
            label="Small"
            className={classes.chip}
          />
        </Hidden>
        <Hidden only={['xs', 'sm', 'lg', 'xl']}>
          <Chip
            avatar={<Avatar>MD</Avatar>}
            label="Medium"
            className={classes.chip}
          />
        </Hidden>
        <Hidden only={['xs', 'sm', 'md', 'xl']}>
          <Chip
            avatar={<Avatar>LG</Avatar>}
            label="Large "
            className={classes.chip}
          />
        </Hidden>
        <Hidden only={['xs', 'sm', 'md', 'lg']}>
          <Chip
            avatar={<Avatar>XL</Avatar>}
            label="Extra Large"
            className={classes.chip}
          />
        </Hidden>
      </span>
    );

    if (inEditMode) {
      editorClass = classes.editorShown;
      editorPanel = (
        <div className={classes.editorPanel}>
          <div className={classes.editorInstructionsArea}>
            <div className={classes.editorInstructions}>
              <p>
                You are now in edit mode. While in edit mode, you will be able
                to arrange and resize dashboard elements. When complete, if you
                are happy with the changes, you can click <strong>Save</strong>{' '}
                to store the new dashboard settings. You can cancel your changes
                by clicking <strong>Cancel</strong>.
              </p>
              <p>
                You can also reset the dashboard to the default settings by
                clicking <strong>Reset to Defaults</strong>.
              </p>
              <p>
                You can also have different arrangements for different window
                sizes. The current window size is shown using the chip below.
              </p>
            </div>
          </div>
          <div className={classes.editorButtons}>
            <div className={classes.editorDangerButtons}>
              <Button
                className={classes.editorResetButton}
                onClick={this.onEditorReset}>
                Reset to Defaults
              </Button>
            </div>
            <div className={classes.chipArea}>{sizer}</div>
            <div className={classes.editorSafeButtons}>
              <Button
                variant="contained"
                color="inherit"
                onClick={this.onEditorCancel}
                className={classes.editorCancelButton}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.onEditorSave}
                className={classes.editorSaveButton}>
                Save
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={editorClass}>
        {editorPanel}
        {!inEditMode && (
          <i
            className={classNames(classes.editorToggle, 'fa fa-cog')}
            onClick={this.enterEditMode}
          />
        )}
      </div>
    );
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {
      status,
      elements,
      elementTypes,
      breakpoints,
      layouts,
      useCSSTransforms,
      inEditMode
    } = this.state;

    const ResponsiveGridLayout = WidthProvider(Responsive);

    switch (status) {
      case 'loading':
        return (
          <AppView history={this.props.history}>
            <div className={classes.container}>
              <LoadingView classes={{}} />
            </div>
          </AppView>
        );
      default:
        layouts = this.deriveLayouts();

        const editor = this.renderEditorPanel();
        return (
          <AppView history={this.props.history} areaKey="internal_dashboard">
            <div className={classes.container}>
              {editor}
              <ResponsiveReactGridLayout
                isDraggable={inEditMode}
                isDroppable={inEditMode}
                isResizable={inEditMode}
                breakpoints={breakpoints}
                onLayoutChange={this.onLayoutChange}
                onBreakpointChange={this.onBreakpointChange}
                rowHeight={30}
                useCSSTransforms={useCSSTransforms}
                cols={{xl: 12, lg: 12, md: 12, sm: 6, xs: 6}}
                layouts={layouts}>
                {elements.map((e, idx) => {
                  let ga: any = {};
                  if (
                    e &&
                    e.elementAttributes &&
                    e.elementAttributes.gridAttributes
                  ) {
                    ga = e.elementAttributes.gridAttributes;
                  }

                  if (inEditMode) {
                    e._elemUpdatedAt = new Date();
                  }
                  return (
                    <div style={{zIndex:100}} key={e.id.toString()}>
                      <DashboardElement
                        element={e}
                        elementType={elementTypes[e.elementType]}
                        onElementsUpdate={this.handleElementsUpdate}
                        inEditMode={inEditMode}
                        caption={translate(e.title)}
                        chromeless={e.elementAttributes.chromeless}
                        classes={{}}
                      />
                    </div>
                  );
                })}
              </ResponsiveReactGridLayout>
            </div>
          </AppView>
        );
    }
  }
}

const defaultLayouts = {
  "xl":  {
    x: 0,
    y: 0,
    w: 4,
    h: 8,
    minW: 1,
    maxW: 12,
  },
  "lg":  {
    x: 0,
    y: 0,
    w: 4,
    h: 8,
    minW: 1,
    maxW: 12,
  },
  "md":  {
    x: 0,
    y: 0,
    w: 4,
    h: 8,
    minW: 1,
    maxW: 12,
  },
  "sm":  {
    x: 0,
    y: 0,
    w: 4,
    h: 8,
    minW: 1,
    maxW: 12,
  },
  "xs":  {
    x: 0,
    y: 0,
    w: 4,
    h: 8,
    minW: 1,
    maxW: 12,
  }
}

export default withStyles(styles)(Dashboard);
